import compileVueTemplateToEditorAst from "../compilers/compileVueTemplateToEditorAst.js"
import compileVueTemplateToEditorScript from "../compilers/compileVueTemplateToEditorScript.js"
import compileEditorAstToVueTemplate from "../compilers/compileEditorAstToVueTemplate.js"
// import compileVueTemplateToEditorScriptAst from "../compilers/__experiment_compileVueTemplateToEditorScriptAst.js"
import compileEditorScriptToVueTemplate from "../compilers/compileEditorScriptToVueTemplate.js"
import { query, mutation } from "../api/queries"
import { deepClone } from "@/utils/"
import api from "@/api/api"

// HACK: just testing ASTs conversions
// const babel = require("@babel/core")

export default {
	async loadApp({ commit, dispatch }, { appId }) {
		commit("setApp", null) // Reset app
		dispatch("selectComponent", null) // REset selected component

		// 1: Fetch app config
		const res = await api({ query: query.cmsConfig, variables: { where: { appId } } })
		const settings = res?.data?.cmsConfigs?.[0] ?? {}
		// TODO: handle errors

		// 2: Fetch all components of the app
		let components = await api({ query: query.components })
		// TODO: handle errors

		// Append properties that we need for the editor
		// - editorAst which is a JSON represenation of template part
		// - editorScript whichc is content of script tag as a string stripped of imports and export statements
		// TODO: refactor - should be a standalone method so that it can be reuseed in createComponent action so taht we keep data structure consistent
		components = (components?.data?.components?.list ?? []).map(component => {
			return {
				id: component?.id,
				name: component?.name,
				version: component?.version,
				editorAst: compileVueTemplateToEditorAst({ vueTemplate: component?.vueTemplate, version: component?.version?.version }),
				editorScript: compileVueTemplateToEditorScript({
					vueTemplate: component?.vueTemplate,
					version: component?.version?.version
				}),
				// NOTE: this was slowing down the whole editore, the ASTs are huge, probably needs to be converted only when needed
				// editorScriptAst: compileVueTemplateToEditorScriptAst({
				// 	vueTemplate: component?.vueTemplate,
				// 	version: component?.version?.version
				// }),
				originalCodeSource: {
					vueTemplate: component?.vueTemplate
				}
			}
		})

		commit("setApp", { ...settings, components })
	},

	async putComponentRoutes({ dispatch }, { appId, componentRoutes }) {
		const resultObject = await dispatch("patchCmsConfig", { appId, config: { componentRoutes } })
		return Promise.resolve(resultObject)
	},

	async updateTheme({ dispatch }, { appId, themeJsonString }) {
		const resultObject = await dispatch("patchCmsConfig", { appId, config: { themeJsonString } })
		return Promise.resolve(resultObject)
	},

	async patchCmsConfig({ commit, state }, { appId, config }) {
		// get all properties of CMS config so that when we do upsert call, we don't override and we keep all other properties untouched
		// upsertCMS would set properties to null if not passed
		const newConfig = { ...deepClone(state.app), ...config }
		delete newConfig.components // remove components, they are not part of cms config

		const res = await api({ query: mutation.upsertCmsConfig, variables: { appId, config: newConfig } })
		if (res?.data?.upsertCmsConfig?.status !== "success") {
			const error = res?.data?.upsertCmsConfig?.errors?.[0] || res?.errors?.[0]?.message
			return Promise.resolve({ isSuccess: false, res, error })
		}

		commit("patchApp", newConfig)
		return Promise.resolve({ isSuccess: true, res, error: null })
	},

	// Components related
	selectComponent({ commit }, componentId = "") {
		commit("selectNode", "") // reset
		commit("selectComponent", componentId)
	},

	async createComponent({ commit }, component) {
		// HACK: should not be hardcoded, somewhre user can say what version of Vue to use
		const input = {
			version: { version: "2.6.11", framework: "vue" },
			name: component.name,
			vueTemplate: component.vueTemplate,
			componentJsonString: "{}" // has to be there otherwise API error
		}

		const res = await api({
			query: mutation.createComponent,
			variables: { input }
		})

		// TODO: check for errors
		console.log({ res })

		// Has to follow data structure for the state.app.components object
		const newComponent = {
			id: res?.data?.createComponent?.createdStatus?.id,
			name: input?.name,
			version: input?.version,
			editorAst: compileVueTemplateToEditorAst({ vueTemplate: input?.vueTemplate, version: input?.version?.version }),
			editorScript: compileVueTemplateToEditorScript({
				vueTemplate: input?.vueTemplate,
				version: input?.version?.version
			}),
			originalCodeSource: {
				vueTemplate: input?.vueTemplate
			}
		}

		// TODO: add into app.components
		commit("createComponent", newComponent)

		return Promise.resolve({ isSuccess: true, res })
	},

	async saveComponent({ state }, { componentId }) {
		console.log("updateComponent")

		const comp = state?.app?.components?.find(comp => comp.id === componentId)
		console.log({ comp })
		if (!comp) return Promise.resolve({ isSuccess: false }) // TODO: return error isSuccess:false

		// Compile editorAst -> vueTemplate
		const template = compileEditorAstToVueTemplate({
			editorAst: comp?.editorAst ?? [],
			mode: "file",
			version: comp?.version?.version
		})

		// Get components dependencies from editorAst
		const extractComponentDependenciesFromEditorAst = (editorAst, customComponents) => {
			const componentDependencies = []

			const recursion = arr => {
				arr.forEach(item => {
					// IF this node is in the list of custom components, inlcude it as a dependency
					if (customComponents.find(comp => comp.name === item.component)) componentDependencies.push(item.component)
					if (item?.children?.length) recursion(item.children)
				})
			}

			recursion(editorAst)
			return componentDependencies
		}

		// Compile editorScript -> vueTemplate
		const script = compileEditorScriptToVueTemplate({
			editorScript: comp?.editorScript,
			version: comp?.version?.version,
			components: extractComponentDependenciesFromEditorAst(comp?.editorAst, state?.app?.components)
			// mixins: ["MyMixin", "AnotherMixin"] // TODO: do mixins with eMD
		})

		// Compose final component
		const vueTemplate = `
			<template>
			${template}
			</template>
			<script>
			${script}
			</script>
			`

		console.log({ comp })
		console.log({ script })
		console.log({ vueTemplate })

		const res = await api({
			query: mutation.updateComponent,
			variables: { id: componentId, input: { vueTemplate } }
		})
		// TODO: handle errors
		console.log({ res })

		return Promise.resolve({ isSuccess: true, res })
	},

	patchComponent({ commit }, { componentId, property, value }) {
		commit("patchComponent", { componentId, property, value })
	},

	async deleteComponent({ commit }, componentId) {
		commit("deleteComponent", componentId)
		commit("selectComponent", null)

		const res = await api({
			query: mutation.deleteComponent,
			variables: { id: componentId }
		})

		// TODO: handle errors

		return Promise.resolve({ isSuccess: true, res })
	},

	// Nodes (elements) related
	selectNode({ commit }, nodeIdToSelect) {
		commit("selectNode", { nodeIdToSelect })
		return Promise.resolve()
	},

	hoverNode({ commit }, nodeIdToHover) {
		commit("hoverNode", { nodeIdToHover })
		return Promise.resolve()
	},

	toggleExpandNode({ commit }, nodeIdToExpand) {
		commit("toggleExpandNode", { nodeIdToExpand })
		return Promise.resolve()
	},

	expandAllNodes({ commit }) {
		commit("expandAllNodes")
		return Promise.resolve()
	},

	putNode({ commit }, node) {
		commit("putNode", node)
	},

	deleteNode({ commit }, nodeToDelete) {
		commit("deleteNode", { nodeToDelete })
		return Promise.resolve()
	}
}
